var countDone = function(list) {
  return list.filter(function(object) {
    return object.allDelivered();
  }).length;
};

var countNotCancelled = function(list) {
  return list.filter(function(object) {
    return object.notCancelled();
  }).length;
};

var countDelivered = function(list) {
  return list.filter(function(object) {
    return object.anyDelivered();
  }).length;
};

var countDeviation = function(list) {
  return list.filter(function(object) {
    return object.allDeviationOrCancelled();
  }).length;
};

var countCancelled = function(list) {
  return list.filter(function(object) {
    return object.allCancelled();
  }).length;
};

function Count(stops) {
  this.stops = stops;

  this.countStopLocationsNotCancelled = function() {
    return countNotCancelled(stops);
  };

  this.countCustomers = function() {
    return stops.reduce(function(count, stop) {
      return count + stop.customers.length;
    }, 0);
  };

  this.countCustomersNotCancelled = function() {
    return stops.reduce(function(count, stop) {
      return count + countNotCancelled(stop.customers);
    }, 0);
  };

  this.countDeliveriesNotCancelled = function() {
    return stops.reduce(function(count, stop) {
      return count + countNotCancelled(stop.deliveries());
    }, 0);
  };

  this.countCustomersDelivered = function() {
    return stops.reduce(function(count, stop) {
      return count + countDelivered(stop.customers);
    }, 0);
  };

  this.countCustomersCancelled = function() {
    return stops.reduce(function(count, stop) {
      return count + countCancelled(stop.customers);
    }, 0);
  };

  this.countCustomersDeviation = function() {
    return stops.reduce(function(count, stop) {
      return count + countDeviation(stop.customers);
    }, 0);
  };

  this.countStopLocationsDone = function() {
    return countDone(stops);
  };

  this.countCustomersDone = function() {
    return stops.reduce(function(count, stop) {
      return count + countDone(stop.customers);
    }, 0);
  };

  this.countDeliveriesDone = function() {
    return stops.reduce(function(count, stop) {
      return count + countDone(stop.deliveries());
    }, 0);
  };

}

module.exports = Count;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/count.js
 ** module id = 11
 ** module chunks = 1
 **/